import type React from 'react';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';
import { BooksPageView } from './BooksPageView';
import { useBooksPage } from './useBooksPage';

/**
 * `/accounting/books` — the tab shell every `/accounting/books*` URL renders.
 *
 * Layout experiment: the ledger screens that `/accounting` gives a sidebar entry
 * each are gathered here behind one nav item and four tabs. No data yet — the
 * four child routes are placeholders — so there is no query hook and no
 * `ErrorBoundary`; both arrive with the first real tab.
 */
export const BooksPage: React.FC = () => {
    const page = useBooksPage();

    return (
        <div
            className="flex w-full flex-col gap-6"
            {...getNodeTestIdProp('books-page')}
        >
            <BooksPageView
                fromDate={page.fromDate}
                note={page.note}
                onRangeChange={page.onRangeChange}
                outletContext={page.outletContext}
                selectedTabId={page.selectedTabId}
                tabs={page.tabs}
                toDate={page.toDate}
            />
        </div>
    );
};
